import ScoreCardsApi from "../api/scoreCards";
import { BaseActions } from "./BaseActions";

export default new (class ScoreCardsActions extends BaseActions {
  constructor() {
    super(ScoreCardsApi, "SCORECARD");
  }
})();
